<template>
  <client-only>
    <div :class="{'info_state': toolbarState}">
      <div v-if="!toolbarState" class="red_bar" @click.stop="onNewsBarClick()">
        <div
          v-if="newsBar"
          class="homeMessage"
          :class="{'regular-text-size': !timeLeftHourse, 'length-fifty': newsBar.length <=50 , 'length-sixty': newsBar.length > 50 && newsBar.length <=60, 'length-seventy': newsBar.length > 60 && newsBar.length <=70, 'length-eighty': newsBar.length > 70 && newsBar.length <=80, 'length-long': newsBar.length >80, 'one-line': !timeLeftHourse }"
        >
          {{ newsBar }}
        </div>
        <div v-if="timeLeftHourse" class="vertical_divider" />
        <div v-if="timeLeftHourse" class="timerBar">
          <transition name="slide-fade" mode="out-in">
            <span :key="timeLeftHourse">
              {{ timeLeftHourse }}
            </span>
          </transition>
          <span class="time_unit">h:</span>
          <transition name="slide-fade" mode="out-in">
            <span :key="timeLeftMinutes">
              {{ timeLeftMinutes }}
            </span>
          </transition>
          <span class="time_unit">m:</span>
          <transition name="slide-fade" mode="out-in">
            <!-- :key="timeLeftSeconds"-->
            <span>
              {{ timeLeftSeconds }}
            </span>
          </transition>
          <span class="time_unit">s</span>
        </div>
      </div>
      <div class="toolbar">
        <div class="top" @mouseenter="onMenuItemLeave()">
          <div class="small_screen">
            <img v-lazy-load data-src="/menu.svg" class="pointer menu_icon" @click="toggleMenu()">
          </div>
          <div class="search_icon" @click="onSearchClick()">
            <img v-lazy-load :data-src="showSearchComponent ? '/clear.svg': '/search.svg'" class="pointer">
          </div>
          <div class="logo">
            <img class="pointer" v-lazy-load data-src="/logo_red.png" @click="goHome()">
          </div>
          <template v-if="!$device.isMobileOrTablet">
            <div class="search_container wide_screen">
              <input
                v-model="search"
                class="search wide_screen"
                placeholder="what do you want to find?"
                @keyup.enter="onEnter"
              >
              <dl
                v-if="!forceHideAutoComplete && search && showAutoComplete"
                :class="{'show': !forceHideAutoComplete && search && showAutoComplete}"
                class="sort auto_filter"
              >
                <dd>
                  <ul>
                    <li v-for="(autoComplete, index) in getAutoCompleteOptions" :key="index">
                      <a @click.stop="onAutoCompleteClicked(index)">{{ autoComplete }}</a>
                    </li>
                  </ul>
                </dd>
              </dl>
            </div>
            <div v-if="!$device.isMobileOrTablet" class="explore" @click.stop="goExplore()">
              Explore
            </div>
            <!--            <div class="sell" @click.stop="goContactUs()">
              Contact
            </div>-->
            <div class="search hidden small_screen" />
            <div class="cart_icon pointer" @click="goToCart()">
              <span v-if="cartCount" class="cart_badge">{{ cartCount }}</span>
              <img class="pointer" v-lazy-load data-src="/cart.svg">
            </div>
            <a class="_0ZPOP kIKUG notification_icon pointer" @click="changeShowNewsState()">
              <span v-if="newsUnread" class="news_badge">{{ newsUnread }}</span>
              <img class="pointer" v-lazy-load data-src="/notification.svg">
            </a>
            <div
              v-if="$store.state.localStorage.currentUser && $store.state.localStorage.currentUser.id < 0"
              class="gotit_button join_gotit"
              @click.stop="joinGotit()"
            >
              Register \ Login
            </div>
            <div
              v-if="$store.state.localStorage.currentUser && $store.state.localStorage.currentUser.id > 0"
              class="profile_icon pointer"
              @click="goToProfile()"
            >
              <img
                v-lazy-load :data-src="$store.state.localStorage.currentUser.profilePhotoThumbnail || 'https://s3.amazonaws.com/app.770apps.images/defult_pic.png'"
                class="pointer"
              >
              <div class="toolbar_username">
                {{ $store.state.localStorage.currentUser.username }}
              </div>
            </div>
            <NewsComponent />
          </template>
          <div
            v-if="$device.isMobileOrTablet && $store.state.localStorage.currentUser && $store.state.localStorage.currentUser.id < 0"
            class="mobile_login pointer"
            @click="login()"
          >
            Sign in
          </div>
        </div>
        <template v-if="!$device.isMobileOrTablet && !toolbarState">
          <div class="categories" @mouseleave="onMenuItemLeave()">
            <div class="main_items">
              <div class="category_item pointer" @mouseenter="onMenuItemLeave()" @click.stop="showAllItems()">
                All
              </div>
              <template v-for="(menuItem, index) in exploreMenuItems">
                <div
                  v-if="menuItem.subEntries"
                  :key="'mi' + index"
                  class="category_item pointer"
                  @mouseenter="onMenuItemEnter(menuItem)"
                  @click.stop="onCategoryClicked(menuItem)"
                >
                  {{ menuItem.name }}
                </div>
              </template>
              <div class="category_item pointer" @mouseenter="onMenuItemLeave()" @click.stop="goExplore()">
                Explore
              </div>
            </div>
            <div
              :class="{'hidden_menu':hidden, 'visible_menu':!hidden}"
              class="sub_categories"
              @mouseenter="hidden = false"
              @mouseleave="onMenuItemLeave()"
            >
              <div class="sub_categories_submenu">
                <div
                  v-for="(menuItem, index) in exploreMenuItems"
                  :key="'mi2' + index"
                  class="category_tree category_sub_item"
                >
                  <template v-if="menuItem.name === currentMenuItem.name">
                    <div
                      v-for="(subMenuItem, indx) in menuItem.subEntries"
                      :key="'mi2' + indx"
                      class="sub_category_sub_item"
                    >
                      <div @click.stop="onCategoryClicked(subMenuItem)">
                        {{ subMenuItem.name }}
                      </div>
                      <template v-if="subMenuItem.subEntries">
                        <div class="sub_sub_menu">
                          <div
                            v-for="(subSubMenuItem, inx) in subMenuItem.subEntries"
                            :key="'smi'+inx"
                            class="sub_sub_category_sub_item"
                            @click.stop="onCategoryClicked(subSubMenuItem)"
                          >
                            {{ subSubMenuItem.name }}
                          </div>
                        </div>
                      </template>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </template>
        <div v-if="showSearchComponent" class="bottom">
          <input
            v-model="search"
            class="search mobile_search"
            placeholder="what do you want to find?"
            @keyup.enter="onEnter"
          >
          <div v-if="search" class="input_search_icon mobile" @click="search = ''">
            <img v-lazy-load :data-src="'/clear.svg'" class="pointer">
          </div>
        </div>
      </div>
    </div>
  </client-only>
</template>
<script>
import NewsComponent from './NewsComponent'

export default {
  name: 'ToolbarComponent',
  components: {
    NewsComponent
  },
  props: {
    toolbarState: {
      default: '',
      type: String
    },
    query: {
      default: '',
      type: String
    },
    forceHideAutoComplete: {
      default: false,
      type: Boolean
    }
  },
  data () {
    return {
      newsBar: '',
      newsUnread: 0,
      cartCount: 0,
      search: '',
      timeLeftHourse: '',
      timeLeftMinutes: '',
      timeLeftSeconds: '',
      exploreMenuItems: null,
      currentMenuItem: {},
      openMenuTimeOut: null,
      hidden: true,
      showAutoComplete: false,
      showSearchComponent: false
    }
  },
  computed: {
    getAutoCompleteOptions () {
      if (this.search) {
        return [this.search + ' in items', this.search + ' in people', this.search + ' in stores']
      } else {
        return []
      }
    }
  },
  watch: {
    search () {
      this.showAutoComplete = true
    }
  },
  mounted () {
    if (!this.$device.isMobileOrTablet) {
      this.exploreMenuItems = [
        {
          name: 'Recommended',
          id: '25',
          subEntries: [
            { name: "Men's", id: '21', path: '/search?category=25,21', breadcrumb: [] }, {
              name: "Women's",
              id: '68',
              path: '/search?category=25,68',
              breadcrumb: []
            }],
          path: '/search?category=25',
          breadcrumb: ['Recommended', "Men's", "Women's"]
        }, {
          name: 'Matching Sets',
          id: '102',
          subEntries: [
            {
              name: 'Create your custom set',
              id: '-1',
              path: '/create-set',
              breadcrumb: []
            },
            {
              name: 'Shirt & Pants Sets',
              id: '103',
              path: '/search?category=102,103',
              breadcrumb: []
            },
            { name: 'Tracksuits', id: '104', path: '/search?category=102,104', breadcrumb: [] },
            {
              name: 'Shorts Sets',
              id: '105',
              path: '/search?category=102,105',
              breadcrumb: []
            }],
          path: '/search?category=102',
          breadcrumb: ['Matching Sets', 'Shirt & Pants Sets', 'Tracksuits', 'Shorts Sets']
        }, {
          name: "Men's",
          id: '21',
          subEntries: [
            {
              name: 'Clothing',
              id: '53',
              subEntries: [{
                name: 'Shirts',
                id: '95',
                path: '/search?category=21,95',
                breadcrumb: []
              },
              { name: 'Jackets & Coats', id: '13', path: '/search?category=21,13', breadcrumb: [] },
              {
                name: 'Sweaters',
                id: '45',
                path: '/search?category=21,45',
                breadcrumb: []
              }, {
                name: 'T-Shirt',
                id: '40',
                subEntries: [{
                  name: 'Polo shirts',
                  id: '15',
                  path: '/search?category=40,21,15',
                  breadcrumb: []
                }, { name: 'Long Sleeve', id: '91', path: '/search?category=40,21,91', breadcrumb: [] }, {
                  name: 'Tanks',
                  id: '67',
                  path: '/search?category=40,21,67',
                  breadcrumb: []
                }, { name: 'Short Sleeve', id: '24', path: '/search?category=40,21,24', breadcrumb: [] }, {
                  name: 'Polo shirts',
                  id: '15',
                  path: '/search?category=40,21,15',
                  breadcrumb: []
                }],
                path: '/search?category=21,40',
                breadcrumb: ['T-Shirt', 'Polo shirts', 'Long Sleeve', 'Tanks', 'Short Sleeve', 'Polo shirts']
              }, { name: 'Sweatshirts', id: '69', path: '/search?category=21,69', breadcrumb: [] }, {
                name: 'Underwear',
                id: '5',
                path: '/search?category=21,5',
                breadcrumb: []
              }, { name: 'Shorts', id: '89', path: '/search?category=21,89', breadcrumb: [] }, {
                name: 'Pants',
                id: '43',
                subEntries: [{ name: 'Joggers', id: '7', path: '/search?category=7', breadcrumb: [] }, {
                  name: 'Chinos',
                  id: '34',
                  path: '/search?category=21,43,34',
                  breadcrumb: []
                }, { name: 'Jeans', id: '29', path: '/search?category=21,43,29', breadcrumb: [] }],
                path: '/search?category=21,43',
                breadcrumb: ['Pants', 'Joggers', 'Chinos', 'Jeans']
              }],
              path: '/search?category=21,53',
              breadcrumb: ['Clothing', 'Shirts', 'Jackets & Coats', 'Sweaters', 'Sweatshirts', 'Underwear', 'Shorts']
            }, {
              name: 'Accessories',
              id: '39',
              subEntries: [{ name: 'Wallets', id: '96', path: '/search?category=39,21,96', breadcrumb: [] }, {
                name: 'Watches',
                id: '64',
                path: '/search?category=39,21,64',
                breadcrumb: []
              }, { name: 'Glasses', id: '26', path: '/search?category=39,21,26', breadcrumb: [] }, {
                name: 'Beauty & Perfumes',
                id: '48',
                path: '/search?category=39,21,48',
                breadcrumb: []
              }, { name: 'Bags', id: '44', path: '/search?category=39,21,44', breadcrumb: [] }, {
                name: 'Jewlery',
                id: '85',
                path: '/search?category=39,21,85',
                breadcrumb: []
              }, { name: 'Caps', id: '80', path: '/search?category=39,21,80', breadcrumb: [] }, {
                name: 'Others',
                id: '42',
                path: '/search?category=31,21,42',
                breadcrumb: []
              }],
              path: '/search?category=21,39',
              breadcrumb: ['Accessories', 'Wallets', 'Watches', 'Glasses', 'Beauty & Perfumes', 'Bags', 'Jewlery', 'Caps', 'Others']
            }, {
              name: 'Shoes',
              id: '38',
              subEntries: [
                { name: 'Sports', id: '90', path: '/search?category=38,21,90', breadcrumb: [] }, {
                  name: 'Sandals',
                  id: '37',
                  path: '/search?category=38,21,37',
                  breadcrumb: []
                }, { name: 'Boots', id: '70', path: '/search?category=38,21,70', breadcrumb: [] }, {
                  name: 'Sneakers',
                  id: '93',
                  path: '/search?category=38,21,93',
                  breadcrumb: []
                }, { name: 'Dress', id: '58', path: '/search?category=38,21,58', breadcrumb: [] }, {
                  name: 'Sports',
                  id: '90',
                  path: '/search?category=38,21,90',
                  breadcrumb: []
                }],
              path: '/search?category=21,38',
              breadcrumb: ['Shoes', 'Sports', 'Sandals', 'Boots', 'Sneakers', 'Dress', 'Sports']
            }],
          path: '/search?category=21',
          breadcrumb: ["Men's"]
        }, {
          name: "Women's",
          id: '68',
          subEntries: [
            { name: 'Beauty', id: '49', path: '/search?category=49', breadcrumb: [] }, {
              name: 'Accessories',
              id: '39',
              subEntries: [{ name: 'Others', id: '42', path: '/search?category=39,68,53,42', breadcrumb: [] }, {
                name: 'Bags',
                id: '44',
                path: '/search?category=44',
                breadcrumb: []
              }, { name: 'Hats', id: '65', path: '/search?category=39,68,53,65', breadcrumb: [] }, {
                name: 'Watches',
                id: '64',
                path: '/search?category=64',
                breadcrumb: []
              }, { name: 'Belts', id: '73', path: '/search?category=39,68,53,73', breadcrumb: [] }, {
                name: 'Jewlery',
                id: '85',
                subEntries: [{ name: 'Earrings', id: '88', path: '/search?category=39,68,53,88', breadcrumb: [] }, {
                  name: 'Rings',
                  id: '60',
                  path: '/search?category=60',
                  breadcrumb: []
                }, { name: 'Necklace', id: '36', path: '/search?category=39,68,53,36', breadcrumb: [] }, {
                  name: 'Bracelet',
                  id: '86',
                  path: '/search?category=39,68,53,86',
                  breadcrumb: []
                }],
                path: '/search?category=85',
                breadcrumb: ['Jewlery', 'Earrings', 'Rings', 'Necklace', 'Bracelet']
              }, { name: 'Sunglasses', id: '16', path: '/search?category=39,68,53,16', breadcrumb: [] }, {
                name: 'Hair',
                id: '66',
                path: '/search?category=39,68,53,66',
                breadcrumb: []
              }],
              path: '/search?category=68,53,39',
              breadcrumb: ['Accessories', 'Others', 'Bags', 'Hats', 'Watches', 'Belts', 'Sunglasses', 'Hair']
            }, {
              name: 'Clothing',
              id: '53',
              subEntries: [{
                name: 'Bras, Panties & Shapewear',
                id: '32',
                path: '/search?category=68,53,32',
                breadcrumb: []
              }, {
                name: 'Tops',
                id: '31',
                subEntries: [{ name: 'Long Sleeve', id: '91', path: '/search?category=31,68,53,91', breadcrumb: [] }, {
                  name: 'Short',
                  id: '2',
                  path: '/search?category=2',
                  breadcrumb: []
                }, { name: 'Dress Shirts', id: '35', path: '/search?category=31,68,53,35', breadcrumb: [] }, {
                  name: 'Tanks',
                  id: '67',
                  path: '/search?category=31,68,53,67',
                  breadcrumb: []
                }],
                path: '/search?category=68,53,31',
                breadcrumb: ['Tops', 'Long Sleeve', 'Short', 'Dress Shirts', 'Tanks']
              }, { name: 'Sweats and Hoodie', id: '76', path: '/search?category=68,53,76', breadcrumb: [] }, {
                name: 'Skirts',
                id: '8',
                path: '/search?category=68,53,8',
                breadcrumb: []
              }, { name: 'Swimwear', id: '6', path: '/search?category=68,53,6', breadcrumb: [] }, {
                name: 'Jumpsuits & Rompers',
                id: '72',
                path: '/search?category=68,53,72',
                breadcrumb: []
              }, { name: 'Jackets & Coats', id: '18', path: '/search?category=68,53,18', breadcrumb: [] }, {
                name: 'Dresses',
                id: '84',
                path: '/search?category=68,53,84',
                breadcrumb: []
              }, {
                name: 'Bottoms',
                id: '79',
                subEntries: [{ name: 'Jeans', id: '29', path: '/search?category=79,68,53,29', breadcrumb: [] }, {
                  name: 'Shorts',
                  id: '89',
                  path: '/search?category=79,68,53,89',
                  breadcrumb: []
                }, { name: 'Joggers', id: '7', path: '/search?category=79,68,53,7', breadcrumb: [] }, {
                  name: 'Pants',
                  id: '43',
                  path: '/search?category=79,68,53,43',
                  breadcrumb: []
                }],
                path: '/search?category=79,68,53,',
                breadcrumb: ['Bottoms', 'Jeans', 'Shorts', 'Joggers', 'Pants']
              }],
              path: '/search?category=68,53',
              breadcrumb: ['Clothing', 'Bras, Panties & Shapewear', 'Sweats and Hoodie', 'Skirts', 'Swimwear', 'Jumpsuits & Rompers', 'Jackets & Coats', 'Dresses']
            }, {
              name: 'Shoes',
              id: '38',
              subEntries: [{ name: 'Sneakers', id: '93', path: '/search?category=38,68,93', breadcrumb: [] }, {
                name: 'High Heels',
                id: '83',
                path: '/search?category=68,38,83',
                breadcrumb: []
              }, { name: 'Boots', id: '70', path: '/search?category=38,68,70', breadcrumb: [] }, {
                name: 'Sports',
                id: '90',
                path: '/search?category=38,68,90',
                breadcrumb: []
              }, { name: 'Flats', id: '97', path: '/search?category=38,68,97', breadcrumb: [] }],
              path: '/search?category=68,38',
              breadcrumb: ['Shoes', 'Sneakers', 'High Heels', 'Boots', 'Sports', 'Flats']
            }, {
              name: 'Beauty',
              id: '49',
              subEntries: [
                { name: 'Make Up', id: '57', path: '/search?category=49,68,57', breadcrumb: [] },
                { name: 'Fragrance', id: '23', path: '/search?category=49,68,23', breadcrumb: [] }, {
                  name: 'Others',
                  id: '42',
                  path: '/search?category=49,68,42',
                  breadcrumb: []
                }, { name: 'Skin Care', id: '30', path: '/search?category=49,68,30', breadcrumb: [] }],
              path: '/search?category=68,49',
              breadcrumb: ['Beauty', 'Make Up', 'Make Up', 'Fragrance', 'Others', 'Skin Care']
            }],
          path: '/search?category=68',
          breadcrumb: ["Women's", 'Beauty']
        }, {
          name: 'Gadgets',
          id: '19',
          subEntries: [{
            name: 'Laptop Accessories',
            id: '50',
            path: '/search?category=19,50',
            breadcrumb: []
          },
          { name: 'Laptop Accessories', id: '50', path: '/search?category=19,50', breadcrumb: [] }, {
            name: 'Other',
            id: '33',
            path: '/search?category=19,33',
            breadcrumb: []
          }, { name: 'Camera', id: '78', path: '/search?category=19,78', breadcrumb: [] }, {
            name: 'Phone Accessories',
            id: '17',
            path: '/search?category=19,17',
            breadcrumb: []
          }, { name: 'Kitchen ', id: '20', path: '/search?category=19,20', breadcrumb: [] }, {
            name: 'Audio',
            id: '63',
            path: '/search?category=19,63',
            breadcrumb: []
          }],
          path: '/search?category=19',
          breadcrumb: ['Gadgets', 'Laptop Accessories', 'Laptop Accessories', 'Other', 'Camera', 'Phone Accessories', 'Kitchen ', 'Audio']
        }, {
          name: 'Plus Size (New)',
          id: '100',
          subEntries: [{
            name: "Men's",
            id: '21',
            subEntries: [{
              name: 'Clothing',
              id: '53',
              subEntries: [{
                name: 'T-Shirt',
                id: '40',
                subEntries: [{
                  name: 'Short Sleeve',
                  id: '24',
                  path: '/search?category=100,53,40,24',
                  breadcrumb: []
                }, { name: 'Long Sleeve', id: '91', path: '/search?category=100,53,40,91', breadcrumb: [] }, {
                  name: 'Tanks',
                  id: '67',
                  path: '/search?category=100,53,40,67',
                  breadcrumb: []
                }, { name: 'Polo shirts', id: '15', path: '/search?category=100,53,40,15', breadcrumb: [] }],
                path: '/search?category=100,53,40',
                breadcrumb: ['T-Shirt', 'Short Sleeve', 'Long Sleeve', 'Tanks', 'Polo shirts']
              }, {
                name: 'Pants',
                id: '43',
                subEntries: [{ name: 'Jeans', id: '29', path: '/search?category=29', breadcrumb: [] }, {
                  name: 'Chinos',
                  id: '34',
                  path: '/search?category=34',
                  breadcrumb: []
                }, { name: 'Jeans', id: '29', path: '/search?category=100,53,43,29', breadcrumb: [] }, {
                  name: 'Joggers',
                  id: '7',
                  path: '/search?category=100,53,43,7',
                  breadcrumb: []
                }],
                path: '/search?category=100,53,43',
                breadcrumb: ['Pants', 'Jeans', 'Chinos', 'Jeans', 'Joggers']
              }, { name: 'Shirts', id: '95', path: '/search?category=100,53,95', breadcrumb: [] }, {
                name: 'Shorts',
                id: '89',
                path: '/search?category=100,53,89',
                breadcrumb: []
              }, { name: 'Sweatshirts', id: '69', path: '/search?category=100,53,69', breadcrumb: [] }, {
                name: 'Sweaters',
                id: '45',
                path: '/search?category=100,53,45',
                breadcrumb: []
              }, { name: 'Jackets & Coats', id: '13', path: '/search?category=100,53,13', breadcrumb: [] }, {
                name: 'Underwear',
                id: '5',
                path: '/search?category=100,53,5',
                breadcrumb: []
              }],
              path: '/search?category=100,53',
              breadcrumb: ['Clothing', 'Shirts', 'Shorts', 'Sweatshirts', 'Sweaters', 'Jackets & Coats', 'Underwear']
            }, {
              name: 'Shoes',
              id: '38',
              subEntries: [{ name: 'Sneakers', id: '93', path: '/search?category=38,93', breadcrumb: [] }, {
                name: 'Dress',
                id: '58',
                path: '/search?category=38,58',
                breadcrumb: []
              }, { name: 'Boots', id: '70', path: '/search?category=38,70', breadcrumb: [] }, {
                name: 'Sports',
                id: '90',
                path: '/search?category=38,90',
                breadcrumb: []
              }, { name: 'Sandals', id: '37', path: '/search?category=38,37', breadcrumb: [] }],
              path: '/search?category=38',
              breadcrumb: ['Shoes', 'Sneakers', 'Dress', 'Boots', 'Sports', 'Sandals']
            }, {
              name: 'Accessories',
              id: '39',
              subEntries: [{
                name: 'Glasses',
                id: '26',
                path: '/search?category=26',
                breadcrumb: []
              }, { name: 'Beauty & Perfumes', id: '48', path: '/search?category=48', breadcrumb: [] }, {
                name: 'Jewlery',
                id: '85',
                path: '/search?category=85',
                breadcrumb: []
              }, { name: 'Bags', id: '44', path: '/search?category=44', breadcrumb: [] }, {
                name: 'Watches',
                id: '64',
                path: '/search?category=64',
                breadcrumb: []
              }, { name: 'Wallets', id: '96', path: '/search?category=96', breadcrumb: [] }, {
                name: 'Caps',
                id: '80',
                path: '/search?category=80',
                breadcrumb: []
              }, { name: 'Others', id: '42', path: '/search?category=42', breadcrumb: [] }],
              path: '/search?category=39',
              breadcrumb: ['Accessories', 'Glasses', 'Beauty & Perfumes', 'Jewlery', 'Bags', 'Watches', 'Wallets', 'Caps', 'Others']
            }],
            path: '/search?category=21',
            breadcrumb: ["Men's"]
          }, {
            name: "Women's",
            id: '74',
            subEntries: [{
              name: 'Clothing',
              id: '53',
              subEntries: [{
                name: 'T-Shirt',
                id: '40',
                subEntries: [{
                  name: 'Short Sleeve',
                  id: '24',
                  path: '/search?category=100,53,74,40,24',
                  breadcrumb: []
                }, { name: 'Long Sleeve', id: '91', path: '/search?category=40,100,74,91', breadcrumb: [] }, {
                  name: 'Tanks',
                  id: '67',
                  path: '/search?category=40,100,74,67',
                  breadcrumb: []
                }, { name: 'Polo shirts', id: '15', path: '/search?category=40,100,74,15', breadcrumb: [] }],
                path: '/search?category=100,74,40',
                breadcrumb: ['T-Shirt', 'Short Sleeve', 'Long Sleeve', 'Tanks', 'Polo shirts']
              }, {
                name: 'Pants',
                id: '43',
                subEntries: [{ name: 'Chinos', id: '34', path: '/search?category=43,100,68,34', breadcrumb: [] }, {
                  name: 'Jeans',
                  id: '29',
                  path: '/search?category=43,100,68,29',
                  breadcrumb: []
                }, { name: 'Joggers', id: '7', path: '/search?category=43,100,68,7', breadcrumb: [] }],
                path: '/search?category=43',
                breadcrumb: ['Pants', 'Chinos', 'Jeans', 'Joggers']
              }, { name: 'Shirts', id: '95', path: '/search?category=100,68,95', breadcrumb: [] }, {
                name: 'Shorts',
                id: '89',
                path: '/search?category=100,68,89',
                breadcrumb: []
              }, { name: 'Sweatshirts', id: '69', path: '/search?category=100,68,69', breadcrumb: [] }, {
                name: 'Jackets & Coats',
                id: '18',
                path: '/search?category=100,68,18',
                breadcrumb: []
              }, { name: 'Underwear', id: '5', path: '/search?category=5', breadcrumb: [] }],
              path: '/search?category=100,68,53',
              breadcrumb: ['Clothing', 'Shirts', 'Shorts', 'Sweatshirts', 'Jackets & Coats', 'Underwear']
            }],
            path: '/search?category=100,68',
            breadcrumb: ["Women's"]
          }],
          path: '/search?category=100',
          breadcrumb: ['Plus Size (New)']
        }, {
          name: 'Kids',
          id: '59',
          subEntries: [{
            name: 'Boys',
            id: '28',
            subEntries: [{ name: 'Tops', id: '31', path: '/search?category=59,28,31', breadcrumb: [] }],
            path: '/search?category=59,28',
            breadcrumb: ['Boys', 'Tops']
          }],
          path: '/search?category=59',
          breadcrumb: ['Kids']
        }, { name: 'Subscriptions', id: '101', path: '/search?category=101', breadcrumb: [] }]
    }
    this.search = this.query
    this.newsUnread = this.$store.state.api.globals.newsUnread
    this.newsBar = this.$store.state.api.globals.homeMessage
    this.cartCount = this.$store.state.api.globals.cartCount
    this.$root.$on('on_globals_ready', () => {
      this.newsUnread = this.$store.state.api.globals.newsUnread
      this.cartCount = this.$store.state.api.globals.cartCount
      this.newsBar = this.$store.state.api.globals.homeMessage
    })
    this.$root.$on('set_toolbar_query', (query) => {
      this.search = query
    })
    this.$root.$on('seeAllNews', () => {
      this.changeShowNewsState()
    })
    this.$root.$on('spacial_credit_time_left', (oldTimer, timeLeft) => {
      this.timeLeftHourse = `${timeLeft.hours}`
      // this.timeLeftHourse = ''
      this.timeLeftMinutes = `${timeLeft.minutes}`
      this.timeLeftSeconds = `${timeLeft.secs}`
    })
  },
  methods: {
    login () {
      this.$root.$emit('toggle_login_menu', {
        cancelable: true
      })
    },
    onCategoryClicked (menuItem) {
      this.$store.dispatch('api/trackEvent', {
        eventName: 'category_menu_click',
        params: {
          userId: this.$store.state.localStorage.currentUser.id,
          path: this.$route.path,
          categoryId: menuItem.id,
          categoryName: menuItem.name
        }
      }).then().catch()
      /* if (this.$router.currentRoute.name !== 'search') {
        this.$store.commit('api/setPriceRangeFilter', '')
        this.$store.commit('api/setGenderFilter', '')
        this.$store.commit('api/setSortFilter', '')
      } */
      if (menuItem.path === '/create-set') {
        this.$store.dispatch('api/sendLogMessage', 'create_set_click_toolbar').then().catch()
        this.$store.dispatch('api/trackEvent', {
          eventName: 'create_set_click_toolbar',
          params: {
            path: this.$route.path,
            page: 'item_page',
            itemId: this.itemId
          }
        }).then().catch()
      }
      this.$router.push({
        path: menuItem.path
      })
    },
    onMenuItemEnter (menuItem) {
      this.currentMenuItem = menuItem
      if (this.hidden) {
        this.openMenuTimeOut = setTimeout(() => {
          this.hidden = false
        }, 250)
      }
    },
    onNewsBarClick () {
      const type = this.$store.state.api.globals.homeMessageUri
      let url = 'https://gotitstores.com/'
      switch (type) {
        case '0':
        case '1':
          url += 'explore'
          break
        case '2':
          // url += 'items/' + objectId
          break
        case '3':
          // url += 'users/' + objectId
          break
        case '5':
          // url += 'orders/' + objectId
          break
        case '6':
          // url += 'offers/' + objectId
          break
        case '7':
          // search
          break
        case '8':
          // home
          break
        case '9':
          // news
          break
        case '10':
          url += 'offers'
          break
        case '11':
          // story dialog
          break
        case '12':
          url += 'cart'
          break
        default:
          break
      }
      if (url !== 'https://gotitstores.com/') {
        setTimeout(function () {
          window.location = url
        }, 25)
      }
    },
    onMenuItemLeave () {
      clearTimeout(this.openMenuTimeOut)
      this.currentMenuItem = {}
      this.hidden = true
    },
    processCategories (categoryTree, categories) {
      const map = {}
      const main = {}
      main.name = 'All'
      const categorieNames = {}
      Object.values(categories).forEach((category) => {
        if (category) {
          categorieNames[category.id] = category.name
        }
      })
      const categoryEntries = {}
      const categoryEntriesList = []
      Object.values(categoryTree).forEach((categoryTree) => {
        const categoryEntry = {}
        categoryEntry.name = categorieNames[categoryTree.categoryId]
        categoryEntry.id = categoryTree.categoryId + ''
        categoryEntries[categoryTree.id] = { first: categoryEntry, second: categoryTree.parentId }
        categoryEntriesList.push({ first: categoryEntry, second: categoryTree.parentId })
        map[categoryEntry.id] = categoryEntry.name
      })
      categoryEntriesList.forEach((categoryEntryPair) => {
        if (categoryEntryPair.second != null) {
          const parentCategoryPair = categoryEntries[categoryEntryPair.second]
          if (parentCategoryPair) {
            const parentCategoryEntry = parentCategoryPair.first
            if (!parentCategoryEntry.subEntries) {
              parentCategoryEntry.subEntries = []
            }
            parentCategoryEntry.subEntries.push(categoryEntryPair.first)
          }
        } else {
          if (!main.subEntries) {
            main.subEntries = []
          }
          main.subEntries.push(categoryEntryPair.first)
        }
      })
      this.$store.commit('localStorage/setCategoryTree', main)
      this.$store.commit('localStorage/setCategoryMap', map)
      return main
    },
    addPaths (categoryTree) {
      if (categoryTree.subEntries) {
        if (!categoryTree.path) {
          categoryTree.path = '/search?category=' + categoryTree.id
        }
        if (!categoryTree.breadcrumb) {
          categoryTree.breadcrumb = []
          categoryTree.breadcrumb.push(categoryTree.name)
        }
        for (let i = 0; i < categoryTree.subEntries.length; i++) {
          if (!categoryTree.subEntries[i].subEntries) {
            categoryTree.subEntries[i].path = '/search?category=' + categoryTree.subEntries[i].id
            if (!categoryTree.subEntries[i].breadcrumb) {
              categoryTree.subEntries[i].breadcrumb = []
              categoryTree.breadcrumb.push(categoryTree.subEntries[i].name)
            }
            // categoryTree.subEntries[i].breadcrumb = categoryTree.subEntries[i].breadcrumb.concat(categoryTree.breadcrumb)
          }
        }
        for (let i = 0; i < categoryTree.subEntries.length; i++) {
          this.addPaths(categoryTree.subEntries[i])
        }
      } else if (!categoryTree.path) {
        categoryTree.path = '/search?category=' + categoryTree.id
        if (!categoryTree.breadcrumb) {
          categoryTree.breadcrumb = []
          categoryTree.breadcrumb.push(categoryTree.name)
        }
      }
    },
    joinGotit () {
      this.$root.$emit('toggle_login_menu', {
        state: 'register'
      })
    },
    changeShowNewsState () {
      this.$root.$emit('toggle_show_news')
    },
    goToCart () {
      this.$store.commit('api/setLastPath', this.$route.name)
      this.$router.push({
        path: '/cart'
      })
    },
    goToProfile () {
      this.$router.push({
        path: '/profile'
      })
    },
    goSell () {
      this.$router.push({
        path: '/sell'
      })
    },
    goContactUs () {
      this.$router.push({
        path: '/contact-us'
      })
    },
    goHome () {
      this.$router.push({
        path: '/'
      })
    },
    showAllItems () {
      this.$router.push({
        path: '/search?category=all'
      })
    },
    goExplore () {
      this.$router.push({
        path: '/explore'
      })
    },
    onSearchCategorySelected (event) {
      this.$emit('search', this.search)
      this.$router.push({
        path: '/search?q=' + this.search
      })
    },
    onSearchClick () {
      this.showSearchComponent = !this.showSearchComponent
    },
    toggleMenu () {
      this.$root.$emit('open_navigation_menu')
    },
    onAutoCompleteClicked (searchIndex) {
      let hash = ''
      if (searchIndex === 0) {
        hash = 'items'
      } else if (searchIndex === 1) {
        hash = 'people'
      } else if (searchIndex === 2) {
        hash = 'stores'
      }
      this.$router.push({
        path: '/search?q=' + this.search + '#' + hash
      })
    },
    onEnter () {
      this.$emit('search', this.search)
      this.$router.push({
        path: '/search?q=' + this.search + (this.$route.hash ? this.$route.hash : '')
      })
      this.showAutoComplete = false
      this.$store.dispatch('api/trackEvent', {
        eventName: 'search_performed',
        params: {
          path: this.$route.path,
          search: this.search
        }
      }).then().catch()
    }
  }
}
</script>
<style scoped>
.toolbar {
  background-color: white;
  position: fixed;
  width: 100% !important;
  top: 0;
  margin-top: 4em;
  z-index: 5000;
  font-weight: 300;
}

.info_state .toolbar {
  margin-top: 0;
}

.mobile_design .toolbar {
  padding-left: 1em;
  padding-right: 1em;
  margin-top: 3.3em;
}

.mobile_design .info_state .toolbar {
  margin-top: 0;
}

.toolbar .top {
  /*560px - main feed width*/
  /*273px - RightComponent width*/
  /*1em - padding between them*/
  width: calc(560px + 1em + 273px);
  margin: auto;
  position: relative;
  text-align: center;
  display: flex;
  align-items: center;
  height: calc(49px + 1em);
  background-color: white;
  border-bottom: 1px solid #F6F6F6;
}

.toolbar img {
  height: 21px;
}

.search_container {
  flex: 1;
  height: 34px !important;
  display: flex;
  flex-direction: column;
  padding-top: 5px;
}

.toolbar .search {
  height: 34px !important;
  flex: 1;
  background: #eff0f1;
  box-shadow: none;
  box-sizing: border-box;
  padding: 6px 7px 4px 15px;
  display: block;
  border-radius: 2px;
  margin: 0 1.8em;
  /*overflow: hidden;*/
  color: #505b67;
  line-height: 24px;
  font-size: 14px;
  font-weight: 500;
  border: 0;
}

.toolbar .logo {
  z-index: 1;
}

.mobile_design .toolbar .logo {
  position: fixed;
  /*top: 1.4em;*/
  width: calc(100% - 1em);
  text-align: center;
  left: auto;
  right: auto;
}

.cart_icon {
  margin-right: 1.5em;
  position: relative;
}

.notification_icon {
  position: relative;
  margin-right: 3em;
}

.cart_badge, .news_badge {
  font-size: 12px;
}

.cart_badge, .news_badge {
  position: absolute;
  width: 15px; /* pixel unit */
  height: 15px;
  border-radius: 50%;
  right: -10px;
  text-align: center;
  background-color: #ed4956;
  color: #fefefe;
  line-height: 100%;
  padding-top: 1.5px;
  padding-left: 1px;
}

.news_badge {
  /*right: 5.3em;*/
  right: -5px;
}

.search.hidden {
  background-color: unset;
}

.toolbar .bottom {
  display: flex;
}

.mobile_search {
  margin: 0.5em !important;
}

.bottom {
  /*box-shadow: 3px 1px 10px 1px #cbcbcb;*/
}

.join_gotit {
  /*margin-right: 1em;*/
  font-size: 0.8em;
}

.hidden_menu {
  height: 0;
  transition: all 0.25s ease-out;
  overflow: hidden;
}

.visible_menu {
  height: auto;
  transition: all 0.25s ease-in;
}

.categories {
  position: fixed;
  display: flex;
  flex-direction: column;
  top: calc(49px + 4em);
  /*font-family: HKGroteskRegular;*/
  width: 100% !important;
  background-color: white;
  /*overflow: hidden;*/
  border-bottom: 1px solid #F6F6F6;
}

.categories .strech {
  height: 49px;
}

.categories .main_items {
  display: flex;
  margin: auto;
  text-align: center;
  /*font-family: HKGroteskBold;*/
  font-weight: bold;
  overflow: hidden;
  align-items: center;
  justify-content: space-between;
  width: calc(560px + 1em + 273px);
  box-sizing: border-box;
}

.category_item {
  color: #373d48;
  border-bottom: 1px solid white;
  padding-top: 1em;
  padding-bottom: 1em;
  cursor: pointer;
  height: 100%;
}

.category_item:hover {
  border-bottom: 1px solid rgba(237, 73, 86, 0.31);
}

.sub_categories_submenu {
  padding: 1em 1em 1em 3em;
}

.sub_categories_submenu .category_sub_item {
  display: flex;
  flex-direction: row;
}

.sub_categories_submenu .category_sub_item > div {
  width: 200px;
}

.main_items .strech {
  padding: 0;
}

.sub_categories {
  width: 805px;
  margin: auto;
}

.sub_category_sub_item > div {
  /*font-family: HKGroteskBold;*/
  font-weight: bold;
  cursor: pointer;
}

.sub_sub_category_sub_item {
  /*font-family: HKGroteskRegular;*/
  cursor: pointer;
}

.sub_sub_menu {
  display: flex;
  flex-direction: column;
}

.sell, .explore {
  /*font-family: HKGroteskBold;*/
  font-weight: bold;
  margin-right: 1em;
  cursor: pointer;
}

.profile_icon {
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: end;
  align-items: end;
}

.profile_icon img {
  border-radius: 50%;
  height: 28px;
  z-index: 2;
  width: 28px;
}

.toolbar_username {
  align-self: center;
  max-width: 80px;
  margin-left: 0.2em;
  white-space: nowrap;
  /*font-family: HKGroteskBold;*/
  font-weight: bold;
  color: #373d48;
  overflow: hidden;
  text-overflow: ellipsis;
}

.auto_filter {
  margin-top: 0.3em;
  margin-left: 1.6em;
  width: 376px;
}

dt a {
  background: #EBECED;
  line-height: 36px;
  font-size: 14px;
  font-weight: 600;
  position: relative;
  border-radius: 5px;
  text-decoration: none;
  display: block;
  color: #373D48;
  padding: 0 28px 0 10px;
}

dt a:before {
  content: '';
  position: absolute;
  top: 50%;
  right: 10px;
  width: 9px;
  background: url("/ic_dropdown.svg") white no-repeat 50% 50%;
  height: 5px;
  opacity: 0.6;
  margin: -3px 0 0;
}

dt a:hover {
  text-decoration: none;
}

li {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  vertical-align: baseline;
  list-style: none;
  quotes: none;
  font-style: normal;
  outline: none;
  -webkit-text-size-adjust: none;
  -webkit-overflow-scrolling: touch;
  -webkit-text-size-adjust: none;
  -ms-text-size-adjust: none;
  text-size-adjust: none;
}

dd {
  position: relative;
  margin-top: 0 !important;
  left: 3px;
  background: #fff;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1), 0 0 1px rgba(0, 0, 0, 0.2);
  border-radius: 5px;
  visibility: hidden;
  padding: 7px 0;
  min-width: calc(100% - 6px);
  opacity: 0;
  margin-top: 1em;
  transition: opacity 0.3s;
  -webkit-transition: opacity 0.3s;
  margin-top: -16px;
  -moz-transition: opacity 0.3s;
}

dl.show {
  z-index: 1;
  overflow: visible;
}

dl.show dd {
  opacity: 1;
  visibility: visible;
}

li a {
  display: block;
  border-radius: 0;
  white-space: nowrap;
  background: none;
  border: 0;
  box-shadow: none;
  text-align: left;
  text-shadow: none;
  font-size: 13px;
  line-height: 17px;
  padding: 6px 13px;
  color: #383d48;
  font-weight: 600;
  text-transform: capitalize;
  cursor: pointer;
  z-index: 20;
}

.menu_icon {
  position: relative;
  z-index: 3;
}

.search_icon, .input_search_icon {
  display: none;
}

.mobile_design .search_icon {
  display: inline-block;
  z-index: 2;
  margin-left: 1em;
  right: 1em;
}

.mobile_design .input_search_icon {
  display: inline-block;
  z-index: 2;
  right: 2em;
}

.mobile_login {
  position: fixed;
  right: 0;
  margin-right: 1em;
  font-weight: bold;
  background-color: rgba(181, 58, 58, 0.70);
  padding: 0.2em;
  padding-left: 0.4em;
  padding-right: 0.4em;
  color: white;
  border-radius: 5px;
  z-index: 3;
}

.input_search_icon.mobile {
  position: absolute;
  margin-top: 0.85em;
}

.red_bar {
  background-color: #ed4956;
  height: 3.5em;
  color: white;
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0;
  width: 100%;
  text-align: center;
  font-size: 16px;
  z-index: 5000;
  vertical-align: center;
  font-weight: bold;
}

.mobile_design .red_bar {
  height: 3em;
  line-height: 3em;
}

.slide-fade-enter-active {
  transition: all .3s ease;
}

.slide-fade-leave-active {
  transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}

.slide-fade-enter, .slide-fade-leave-to
  /* .slide-fade-leave-active for <2.1.8 */
{
  transform: translateY(20px);
  opacity: 0.5;
}

.mobile_design .homeMessage, .mobile_design .timerBar {
  width: 50%;
  line-height: 1.3em;
}

.mobile_design .one-line {
  width: 100%;
}

.mobile_design .homeMessage {
  font-size: 2.7vw;
  text-align: center;
  padding-left: 1em;
  padding-right: 1em;
}

.mobile_design .homeMessage.regular-text-size {
  font-size: 3.4vw;
  text-align: center;
  padding-left: 1em;
  padding-right: 1em;
}

.timerBar span {
  display: inline-block;
}

.timerBar {
  font-size: 1.7em;
  font-weight: 900;
  height: 100%;
  padding-top: 17px;
}

.mobile_design .timerBar {
  font-size: 1.4em;
  padding-top: 0;
  height: unset;
}

.vertical_divider {
  background-color: white;
  width: 1px;
  height: 65%;
  margin-left: 1em;
  margin-right: 1em;
}

.mobile_design .vertical_divider {
  margin-left: 0;
  margin-right: 0;
}

.time_unit {
  font-size: 0.7em;
  margin-left: -0.4em;
  font-weight: 400;
}

/*.mobile_design .red_bar div.length-fifty {*/
/*  font-size: 3.7vw;*/
/*}*/
/*.mobile_design .red_bar div {*/
/*  font-size: calc((45vw - 4.5rem) / 7)*/
/*}*/
/*

.mobile_design .red_bar div.length-sixty {
  font-size: 3.4vw;
}

.mobile_design .red_bar div.length-seventy {
  font-size: 2.8vw;
}

.mobile_design .red_bar div.length-eighty {
  font-size: 2.4vw;
}

.mobile_design .red_bar div.length-long {
  font-size: 2.1vw;
}*/

</style>
